<template>
    <div class="articleDetail-container">
        <div v-html="articleDetail.title" class="title"></div>
        <div class="nameAndClock">
            <div class="name">
                <i></i>
                <p :title="articleDetail.user_name">{{articleDetail.user_name}}</p>
            </div>
            <div class="clock">
                <i></i>
                <p>{{articleDetail.raw_update_time}}</p>
            </div>
        </div>
        <div class="source">
            <p>信源：{{articleDetail.source_info || '无'}}</p>
            <p v-if="this.articleDetail.id != 0" @click="navigateTo">查看原文</p>
        </div>
        <div v-html="articleDetail.content" class="content">
            
        </div>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";

export default {
    name: 'newMaterialArticleDetail',
    data() {
        return {

        }
    },
    props: {
        articleDetail: {
            type: Object
        }
    },
    methods: {
        navigateTo() {
            if(this.articleDetail.subject_type - 0 === 0) {
                common.jump(`/clueDetail?d=${this.articleDetail.id}`, true);
            }else if(this.articleDetail.subject_type - 0 === 1) {
                common.jump(`/reportDetail?d=${this.articleDetail.id}`, true);
            }else if(this.articleDetail.subject_type - 0 === 2) {
                common.jump(`/publishDetail?d=${this.articleDetail.id}`, true);
            }else if(this.articleDetail.subject_type - 0 === 5) {
                common.jump(`/mediaPublishDetail?d=${this.articleDetail.id}`, true);
            }
        }
    },
    mounted() {
        // this.articleDetail = this.deposeAudioSrc(this.articleDetail)
        console.log(this.articleDetail)
    }
}
</script>

<style lang="less" scoped>
    .articleDetail-container {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 26px 20px 0;
        box-sizing: border-box;

        .title {
            font-size: 20px;
            line-height: 30px;
            color: #050F0F;
            font-weight: bold;
            margin-bottom: 10px;
        }

        .nameAndClock {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;

            .name {
                display: flex;
                flex-direction: row;
                align-items: center;
                color: #050F0F;
                font-size: 14px;
                line-height: 20px;

                i {
                    display: block;
                    min-width: 18px;
                    min-height: 18px;
                    background: url('../../../common/newMaterialBox/assets/name.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 8px;
                }

                p {
                    max-width: 170px;
                    overflow: hidden;
                    white-space: nowrap;
	                text-overflow: ellipsis;
                }
            }

            .clock {
                display: flex;
                flex-direction: row;
                align-items: center;
                color: #050F0F;
                font-size: 14px;
                line-height: 20px;

                i {
                    display: block;
                    width: 18px;
                    height: 18px;
                    background: url('../../../common/newMaterialBox/assets/clock.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 8px;
                }
            }
        }

        .source {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 14px;

            p {
                font-size: 14px;
                line-height: 20px;
                color: #050F0F;
                font-weight: 500;

                &:nth-last-of-type(1) {
                    color: #41B48C;
                    font-weight: bold;
                    user-select: none;
                    cursor: pointer;
                }
            }
        }

        .content {
            flex: 1;
            min-height: 0;
            padding: 14px 0;
            box-sizing: border-box;
            border-top: 1px solid #F0F0F0;
            word-break: break-all;
            white-space: pre-wrap;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 6px;
                height: 0;
                margin-right: 2px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(5, 15, 15, 0.6);
                border-radius: 4px;
            }
        }
    }
</style>

<style lang="less">
    .articleDetail-container {
        .title {
            em {
                color: #41B48C;
                font-style: normal;
            }
        }

        .content {
            line-height: 28px;

            em {
                color: #41B48C;
                font-style: normal;
            }

            img {
                max-width: 100% !important;
            }

            video {
                max-width: 100% !important;
            }
        }
    }
</style>